import { createContext, useContext } from "solid-js";
import { Loader, LoaderOptions } from 'google-maps';
const GoogleMapsContext = createContext();

export function GoogleMapsProvider(props: any) {
    const loaderOpts: LoaderOptions = { libraries: ["visualization", "maps"] };
    const loader = new Loader(props.apiKey, loaderOpts);
    const google = loader.load();
   return (
    <GoogleMapsContext.Provider value={google}>
      {props.children}
    </GoogleMapsContext.Provider>
  );
}

export function useGoogleMaps() { return useContext(GoogleMapsContext); }